export default __webpack_public_path__ + "static/media/photo--lg--wheel-7.3908f629.jpg";